/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { PricingScheduleItemDto } from "./PricingScheduleItemDto";
import {
    PricingScheduleItemDtoFromJSON,
    PricingScheduleItemDtoFromJSONTyped,
    PricingScheduleItemDtoToJSON,
} from "./PricingScheduleItemDto";

/**
 *
 * @export
 * @interface PricingScheduleDto
 */
export interface PricingScheduleDto {
    /**
     *
     * @type {number}
     * @memberof PricingScheduleDto
     */
    pricingScheduleId?: number;
    /**
     * Optional. Set this to add new schedule to existing schedule group.Omit to create a new schedule and assign to new group
     * @type {number}
     * @memberof PricingScheduleDto
     */
    pricingScheduleGroupId?: number;
    /**
     * The time zone the template is for, eg 'Australia/Melbourne', 'UTC+10' (NEM time).
     * Certain retailers still define peak/off-peak rates in the NEM timezone, which is UTC+10 everywhere. In this case, explicitly set the timezone on the template.
     *  Default timezone is UTC.
     * @type {string}
     * @memberof PricingScheduleDto
     */
    timeZone?: string;
    /**
     * Optional user facing name, eg 'MyRetailer SimplePlan Off-Peak'
     * @type {string}
     * @memberof PricingScheduleDto
     */
    description?: string;
    /**
     * Schedules are ordered by Organisation.RowSequence, PricingSchedule.RowSequence asc.
     * @type {number}
     * @memberof PricingScheduleDto
     */
    rowSequence?: number;
    /**
     * Optional. Sys admins can set this if required. For all other users, their organisation will be used
     * @type {string}
     * @memberof PricingScheduleDto
     */
    organisationId?: string;
    /**
     * Read-only org name
     * @type {string}
     * @memberof PricingScheduleDto
     */
    organisationName?: string;
    /**
     * ISO 4217 currency code
     * @type {string}
     * @memberof PricingScheduleDto
     */
    currencyCode?: string;
    /**
     *
     * @type {boolean}
     * @memberof PricingScheduleDto
     */
    isDeleted?: boolean;
    /**
     * List of connector pricing schedules
     * @type {Array<PricingScheduleItemDto>}
     * @memberof PricingScheduleDto
     */
    scheduleItems?: Array<PricingScheduleItemDto>;
    /**
     * Optional. Will be effective immediately if omitted
     * @type {Date}
     * @memberof PricingScheduleDto
     */
    effectiveFrom?: Date;
    /**
     * If true, delete all future dated schedules in assignation. No effect if PricingScheduleAssignmentId is null.
     * @type {boolean}
     * @memberof PricingScheduleDto
     */
    removeFuturePricingSchedules?: boolean;
}

/**
 * Check if a given object implements the PricingScheduleDto interface.
 */
export function instanceOfPricingScheduleDto(
    value: object,
): value is PricingScheduleDto {
    return true;
}

export function PricingScheduleDtoFromJSON(json: any): PricingScheduleDto {
    return PricingScheduleDtoFromJSONTyped(json, false);
}

export function PricingScheduleDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): PricingScheduleDto {
    if (json == null) {
        return json;
    }
    return {
        pricingScheduleId:
            json["pricingScheduleId"] == null
                ? undefined
                : json["pricingScheduleId"],
        pricingScheduleGroupId:
            json["pricingScheduleGroupId"] == null
                ? undefined
                : json["pricingScheduleGroupId"],
        timeZone: json["timeZone"] == null ? undefined : json["timeZone"],
        description:
            json["description"] == null ? undefined : json["description"],
        rowSequence:
            json["rowSequence"] == null ? undefined : json["rowSequence"],
        organisationId:
            json["organisationId"] == null ? undefined : json["organisationId"],
        organisationName:
            json["organisationName"] == null
                ? undefined
                : json["organisationName"],
        currencyCode:
            json["currencyCode"] == null ? undefined : json["currencyCode"],
        isDeleted: json["isDeleted"] == null ? undefined : json["isDeleted"],
        scheduleItems:
            json["scheduleItems"] == null
                ? undefined
                : (json["scheduleItems"] as Array<any>).map(
                      PricingScheduleItemDtoFromJSON,
                  ),
        effectiveFrom:
            json["effectiveFrom"] == null
                ? undefined
                : new Date(json["effectiveFrom"]),
        removeFuturePricingSchedules:
            json["removeFuturePricingSchedules"] == null
                ? undefined
                : json["removeFuturePricingSchedules"],
    };
}

export function PricingScheduleDtoToJSON(
    value?: PricingScheduleDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        pricingScheduleId: value["pricingScheduleId"],
        pricingScheduleGroupId: value["pricingScheduleGroupId"],
        timeZone: value["timeZone"],
        description: value["description"],
        rowSequence: value["rowSequence"],
        organisationId: value["organisationId"],
        organisationName: value["organisationName"],
        currencyCode: value["currencyCode"],
        isDeleted: value["isDeleted"],
        scheduleItems:
            value["scheduleItems"] == null
                ? undefined
                : (value["scheduleItems"] as Array<any>).map(
                      PricingScheduleItemDtoToJSON,
                  ),
        effectiveFrom:
            value["effectiveFrom"] == null
                ? undefined
                : value["effectiveFrom"].toISOString(),
        removeFuturePricingSchedules: value["removeFuturePricingSchedules"],
    };
}
